import { z } from '@betty/toolkit/api';

export const DepositLimitSchema = z.object({
  type: z.string(),
  period: z.string().optional(),
  amount: z.number().optional(),
  accumulatedAmount: z.number(),
  pendingAmount: z.number().optional(),
  activeFrom: z.string().optional(),
  setAt: z.string().optional(),
});

export const DepositAmountSchema = z.object({
  amount: z.number(),
  isDisabled: z.boolean(),
});

export const ApplePayConfigSchema = z.object({
  countryCode: z.string(),
  currencyCode: z.string(),
  merchantIdentifier: z.string(),
  requestBillingAddress: z.boolean(),
  requestPayerEmail: z.boolean(),
  requestShipping: z.boolean(),
  supportedNetworks: z.array(z.string()),
});

export const DepositSettingsSchema = z.object({
  minAmount: z.number(),
  maxAmount: z.number(),
  defaultAmount: z.number(),
  limits: z.array(DepositLimitSchema),
  availableAmounts: z.array(DepositAmountSchema),
  applePayConfig: ApplePayConfigSchema.optional(),
});
